exports.f = require('./_wks');


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/~/core-js/library/modules/_wks-ext.js
// module id = 214
// module chunks = 0